import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'testFilter'
})
export class TestFilterPipe implements PipeTransform {

  transform(tests: any[], text: string): any[] {
    let response = [];
    if (text === '') {
      return tests;
    }
    text = text.replace('mmpi-', 'mmpi')
    text = text.replace('mmpi-', 'mmpi');
    text = text.replace('kostic', 'kostik');
    text = text.replace('barsit', 'barsic');
    text = text.replace('allp', 'all p');
    text = text.replace('bis-', 'bis');

    // console.log('Filtering tests with text:', text);

    tests.forEach(test => {

      if (test.evaluatedName.toLowerCase().includes(text.toLowerCase()) || test.evaluated.toLowerCase().includes(text.toLowerCase()) || test.type.toLowerCase().includes(text.toLowerCase()) || (test.tags &&test.tags.map(t => t.name.toLowerCase()).find(lcTag => lcTag.includes(text.toLowerCase())))){
        if (response.findIndex(t => t._id === test._id) === -1){
          response.push(test);
        }
      }

    });

    return response;
  }

}
